import { useParams } from "react-router-dom";

const PAGES = {
  impressum: ["Impressum", "Angaben gemäß § 5 DDG\n\nJolgen Cards\n[Vor- und Nachname]\n[Straße Hausnummer]\n[PLZ Ort]\nDeutschland\n\nE-Mail: [kontakt@pn28cards.de]\n\nKleinunternehmer gemäß § 19 UStG / USt-IdNr.: [falls vorhanden]"],
  datenschutz: ["Datenschutzerklärung", "Wir verarbeiten personenbezogene Daten ausschließlich zur Abwicklung deiner Bestellung (Name, Adresse, E-Mail). Zahlungen werden über Stripe bzw. PayPal abgewickelt – wir speichern keine Zahlungsdaten.\n\n[Vollständige Datenschutzerklärung vor dem Launch ergänzen]"],
  agb: ["Allgemeine Geschäftsbedingungen", "[AGB vor dem Launch ergänzen – z. B. Vertragsschluss, Preise, Versand, Zahlung, Eigentumsvorbehalt, Gewährleistung]"],
  widerruf: ["Widerrufsbelehrung", "Du hast das Recht, binnen vierzehn Tagen ohne Angabe von Gründen diesen Vertrag zu widerrufen. Versiegelte Produkte müssen ungeöffnet zurückgesendet werden.\n\n[Vollständige Widerrufsbelehrung & Muster-Widerrufsformular vor dem Launch ergänzen]"],
};

export default function Legal() {
  const { page } = useParams();
  const [title, body] = PAGES[page] || PAGES.impressum;
  return (
    <div className="bg-[#F7F5FB] min-h-[60vh]">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 py-16">
        <h1 className="font-display text-4xl sm:text-5xl text-[#120E1F]" data-testid="legal-title">{title}</h1>
        <p className="mt-8 whitespace-pre-line text-[#120E1F]/80 leading-relaxed">{body}</p>
      </div>
    </div>
  );
}
